/**
 * Normalizes an unknown error into an Error object
 * @param err - The caught error
 * @returns A proper Error object
 */
export function normalizeError(err: unknown): Error {
    if (err instanceof Error) {
        return err;
    }

    if (typeof err === "string") {
        return new Error(err);
    }

    return new Error(String(err));
}
